import { render, staticRenderFns } from "./EntityBadge.vue?vue&type=template&id=7e960d02&scoped=true"
import script from "./EntityBadge.vue?vue&type=script&lang=js"
export * from "./EntityBadge.vue?vue&type=script&lang=js"
import style0 from "./EntityBadge.vue?vue&type=style&index=0&id=7e960d02&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e960d02",
  null
  
)

export default component.exports